import { fetcher } from '@commenda/utils';

// CSM links the Commenda Company to a deal-first quote after signature — backfills the quote and its
// buyer with the company.
export const linkQuoteCompany = async (quoteId: string, companyId: number) => {
  const response = await fetcher(
    `commenda-billing/quotes/${quoteId}/link-company`,
    {
      method: 'POST',
      body: { companyId },
    }
  );

  return response;
};
